import { render, staticRenderFns } from "./EditarNomeUnidadeEtiqueta.vue?vue&type=template&id=df0dd1fa"
import script from "./EditarNomeUnidadeEtiqueta.vue?vue&type=script&lang=js"
export * from "./EditarNomeUnidadeEtiqueta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports